import { createSlice } from "@reduxjs/toolkit";
import { PayloadAction } from "@reduxjs/toolkit";

export type layout_types =  'toggle-desktop-menu' | null;
export type ai_mcat_chat_status =  'open' | 'closed' | 'hidden';

interface LayoutState {
    layoutMode: layout_types;
    aiMCATChatDrawerStatus: ai_mcat_chat_status;
    toggleAiMCATDrawerExternally: boolean;
    toggleMobileMenu: boolean;
    isShowACTPopup: boolean;
    isIframeRefreshing: boolean;
    iframeModal: {
        isOpen: boolean;
        url: string;
        title?: string;
    };
}

const initialState: LayoutState = {
    layoutMode: null,
    aiMCATChatDrawerStatus: 'hidden',
    toggleAiMCATDrawerExternally: false,
    toggleMobileMenu: false,
    isShowACTPopup: false,
    isIframeRefreshing: false,
    iframeModal: {
        isOpen: false,
        url: '',
        title: 'Content'
    }
};

export const layoutSlice = createSlice({
    name: "layout", 
    initialState,
    reducers: {
        setLayout: (state, action: PayloadAction<LayoutState["layoutMode"]>) => {
            state.layoutMode = action.payload;
        },
        setAIMCATChatStatus: (state, action: PayloadAction<ai_mcat_chat_status>) => {
            state.aiMCATChatDrawerStatus = action.payload;
        },
        setToggleAiMCATDrawerExternally: (state, action: PayloadAction<boolean>) => {
            state.toggleAiMCATDrawerExternally = action.payload;
        },
        setToggleMobileMenu: (state, action: PayloadAction<boolean>) => {
            state.toggleMobileMenu = action.payload;
        },
        setIsShowACTPopup: (state, action: PayloadAction<boolean>) => {
            state.isShowACTPopup = action.payload;
        },
        openIframeModal: (state, action: PayloadAction<{ url: string; title?: string }>) => {
            state.iframeModal.isOpen = true;
            state.iframeModal.url = action.payload.url;
            state.iframeModal.title = action.payload.title || 'Content';
        },
        closeIframeModal: (state) => {
            state.iframeModal.isOpen = false;
            state.iframeModal.url = '';
        },
        setIsIframeRefreshing: (state, action: PayloadAction<boolean>) => {
            state.isIframeRefreshing = action.payload;
        },
    },
});


export const {setLayout, setAIMCATChatStatus, setToggleAiMCATDrawerExternally, setToggleMobileMenu, openIframeModal, closeIframeModal, setIsShowACTPopup, setIsIframeRefreshing} = layoutSlice.actions;
export default layoutSlice.reducer;